import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PreventivoState {
    payload: any | null;
}

const initialState: PreventivoState = {
    payload: null,
};

const preventivoSlice = createSlice({
    name: 'preventivo',
    initialState,
    reducers: {
        setPreventivoPayload: (state, action: PayloadAction<any>) => {
            state.payload = action.payload;
        },
        clearPreventivoPayload: (state) => {
            state.payload = null;
        }
    },
});

export const { setPreventivoPayload, clearPreventivoPayload } = preventivoSlice.actions;
export default preventivoSlice.reducer;
